import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import React from 'react';
import { Store } from '../../../types';
import { isPlainLeftClick } from '../../../utils/navigation';

interface StoreTileProps {
  store: Store;
  onClick: () => void;
}

export const StoreTile: React.FC<StoreTileProps> = ({ store, onClick }) => {
  return (
    <a
      href={`/stores/${store.storeName}`}
      onClick={(e) => {
        if (!isPlainLeftClick(e)) {
          return;
        }

        e.preventDefault();
        onClick();
      }}
      className="block bg-white p-4 rounded-lg shadow-md hover:shadow-lg cursor-pointer transition-shadow"
    >
      <div className="flex justify-between items-start mb-2">
        <h3 className="font-semibold text-lg">{store.legibleName}</h3>
        <ChevronRightIcon className="w-5 h-5 text-gray-400" />
      </div>
      <p className="text-gray-600 text-sm mb-1">{store.storeName}</p>
      <p className="text-gray-500 text-xs">{store.chainLegibleName}</p>
      <div className="mt-2 flex items-center justify-between">
        <span className="text-xs text-gray-500">{store.timeZone}</span>
        <span
          className={`px-2 py-1 rounded-full text-xs ${
            store.isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
          }`}
        >
          {store.isActive ? 'Active' : 'Inactive'}
        </span>
      </div>
    </a>
  );
};

export default StoreTile;
